import { render, staticRenderFns } from "./PaymentSlip.vue?vue&type=template&id=3f0cedb8&scoped=true"
import script from "./PaymentSlip.vue?vue&type=script&lang=js"
export * from "./PaymentSlip.vue?vue&type=script&lang=js"
import style0 from "./PaymentSlip.vue?vue&type=style&index=0&id=3f0cedb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0cedb8",
  null
  
)

export default component.exports